<div class="attachment-container">
  <div class="attachment-tools">
    <div class="attachment-actions">
      <!-- File attachment -->
      <button type="button" class="action-button" matTooltip="Attach file" matTooltipPosition="above" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      <input #fileInput type="file" multiple style="display: none;" (change)="onFileSelected($event)" />
      
      <!-- Signature (only for emails) -->
      <div class="action-wrapper" *ngIf="!isSms && showSignature">
        <button type="button" class="action-button" [class.active]="isSignatureDropdownVisible" matTooltip="Signature" matTooltipPosition="above" (click)="toggleSignatureDropdown()">
          <mat-icon>gesture</mat-icon>
        </button>
        
        <!-- Signature dropdown menu -->
        <div *ngIf="isSignatureDropdownVisible" class="dropdown-menu">
          <div class="dropdown-item empty-state" *ngIf="!signatures || signatures.length === 0">
            <mat-icon class="small-icon">info</mat-icon>
            <span>No signatures added yet</span>
          </div>
          <div class="dropdown-item" *ngIf="signatures && signatures.length > 0" (click)="selectSignature()">
            <mat-icon class="small-icon">check</mat-icon>
            <span>Signature</span>
          </div>
          <div class="dropdown-item manage-item" (click)="manageSignatures()">
            <mat-icon class="small-icon">settings</mat-icon>
            <span>Manage signatures</span>
          </div>
        </div>
      </div>
      
      <!-- Camera -->
      <button type="button" class="action-button" matTooltip="Camera" matTooltipPosition="above" (click)="openCamera()">
        <mat-icon>camera_alt</mat-icon>
      </button>
      
      <!-- Voice recording -->
      <button type="button" class="action-button" 
              [class.active]="showAudioRecorder" 
              matTooltip="Voice recording" 
              matTooltipPosition="above" 
              (click)="openVoiceRecorder()">
        <mat-icon>keyboard_voice</mat-icon>
      </button>
    </div>
    
    <!-- Send/Delete actions -->
    <div class="send-actions" *ngIf="showSentButons">
      <button class="action-button delete-button" matTooltip="Remove" matTooltipPosition="above" (click)="cancel()">
        <mat-icon>delete</mat-icon>
      </button>
      <button class="send-button" matTooltip="Send message" matTooltipPosition="above" (click)="sendEmailOrSms()">
        <i-tabler name="send" class="send-icon"></i-tabler>
        <span>Send</span>
      </button>
    </div>
  </div>
  
  <!-- Audio recorder component (shown when active) -->
  <div *ngIf="activeComponent" class="recorder-container">
    <app-recording-audio
      [setCostumWidth]="400"
      [currentAction]="showAudioRecorder"
      (recordingComplete)="onRecordingComplete($event)"
    ></app-recording-audio>
  </div>
</div>